export const PHONE_DISPLAY = "+39 370 374 1644";
export const PHONE_TEL = "tel:+393703741644";
export const WHATSAPP_NUMBER = "393703741644";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const BOOKING_URL = "https://johntartarino.avatable.com/it/prenota";
export const VINOPOLIS_URL = "#"; // placeholder: link app eventi Vinopolis
export const BISTECCHINO_URL = "https://www.johnbistecchino.it";
export const INSTAGRAM_URL = "https://www.instagram.com/johntartarino/";
export const FACEBOOK_URL = "https://www.facebook.com/4dita/";
export const LIKEFOLLONICA_URL = "https://www.likefollonica.it";
export const ADDRESS = "Via Martiri della Niccioleta 13, 58022 Follonica (GR)";
export const GOOGLE_MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Via+Martiri+della+Niccioleta+13+Follonica";
export const MAPS_EMBED =
  "https://maps.google.com/maps?q=Via%20Martiri%20della%20Niccioleta%2013%20Follonica&t=&z=17&ie=UTF8&iwloc=&output=embed";
export const MENU_PDF_URL = "/menu-john-tartarino.pdf";

export const fbqContact = () => {
  if (window.fbq) {
    window.fbq("track", "Contact", {
      content_name: "Prenota WhatsApp",
      content_category: "John Tartarino",
    });
  }
};

export const gaEvent = (name, params = {}) => {
  if (window.gtag && localStorage.getItem("jt-consent") === "yes") {
    window.gtag("event", name, params);
  }
};

export const trackEvent = (type) => {
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/event`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ type, ua: navigator.userAgent }),
  }).catch(() => {});
};

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const MENU = [
  {
    id: "antipasti",
    label: "Antipasti",
    note: "Per cominciare, con calma",
    items: [
      { name: "Selezione di Formaggi", desc: "Eccellenze casearie locali con accompagnamenti", price: "17" },
      { name: "Millefoglie di Melanzane", desc: "Tortino al forno, stracciatella di bufala, olio al basilico, vellutata di pomodoro", price: "13" },
      { name: "Tris di Carpacci", desc: "Chianina marinata, controfiletto ai porcini, Black Angus affumicato e pomodorini secchi", price: "19" },
      { name: "Tuscan Tour", desc: "Prosciutto crudo, salame, finocchiona, pancetta, crostini di fegatini, olive nere condite", price: "21" },
      { name: "Patanegra e Cecina", desc: "Patanegra di bellota 100% iberico, Cecina de León, cotto di Patanegra, pomodorini secchi", price: "29" },
      { name: "Selvaggina", desc: "Salame e salsiccia di cinghiale, mortadella di cinghiale al tartufo, petto d'anatra affumicato, salame di cervo, crostini misti", price: "21" },
    ],
  },
  {
    id: "tartare",
    label: "Le Tartare",
    note: "Per intenditori — battute al coltello",
    items: [
      { name: "La Classica", desc: "Manzo, capperi sottaceto, cetriolini, senape, tuorlo, cipollina, salsa Worcester", price: "17" },
      { name: "Botticelli", desc: "Pomodoro battuto, capperi, olive taggiasche, fiocchi di stracciatella, lime e basilico", price: "19" },
      { name: "Brezza Marina", desc: "Pane croccante, mostarda di frutta, burro alle acciughe", price: "17" },
      { name: "Tartare sull'Osso", desc: "Su osso cotto col suo midollo, tuorlo marinato, panko, granella di arachidi", price: "21" },
      { name: "Tartare Royale", desc: "Fonduta d'uovo a bassa temperatura, crumble di prosciutto croccante e tartufo nero", price: "23" },
      { name: "Pollock", desc: "Un quadro d'arte moderna: le salse dello chef per condire la tartare a piacere", price: "17" },
    ],
  },
  {
    id: "pasta",
    label: "La Pasta",
    note: "Tirata a mano, come si deve",
    items: [
      { name: "Carbonara al Tartufo", desc: "Uovo, tartufo, guanciale e formaggio · anche senza tartufo 17", price: "25" },
      { name: "Pappardelle al Cinghiale", desc: "Pasta toscana con antica ricetta di ragù di cinghiale", price: "17" },
      { name: "Pici al Ragù Bianco", desc: "Pasta tipica toscana, ragù di manzo senza pomodoro", price: "17" },
    ],
  },
  {
    id: "stracotte",
    label: "Le Stracotte",
    note: "Cotture lente a bassa temperatura",
    items: [
      { name: "Short Ribs", desc: "Costole di manzo cotte a bassa temperatura, con patate arrosto", price: "25" },
      { name: "Brisket", desc: "Punta di petto intenerita e insaporita, a bassa temperatura su crunchy di patate", price: "21" },
      { name: "Guancia al Monteregio", desc: "Guancia marinata al vino rosso, a bassa temperatura, con sformato di verdure", price: "23" },
    ],
  },
  {
    id: "griglia",
    label: "Dalla Griglia",
    note: "Brace vera, tagli d'autore",
    items: [
      { name: "La Fiorentina", desc: "Lombata con osso e filetto, sezionata e servita su ghisa calda · circa 1,2 kg", price: "7/hg" },
      { name: "Costata", desc: "Lombata con osso su ghisa calda, olio EVO, sale e pepe · circa 1,2 kg", price: "6,50/hg" },
      { name: "Filetto", desc: "Filetto di bovino alla griglia, sale, olio e pepe rosa · circa 250 g", price: "25" },
      { name: "Ribeye", desc: "Lombata con osso alla griglia, sale, olio e pepe rosa · circa 350 g", price: "33" },
      { name: "Tagliata", desc: "Manzo di prima scelta servito già sezionato, sale e olio · circa 250 g", price: "19" },
    ],
  },
  {
    id: "contorni",
    label: "Contorni",
    note: "Per accompagnare, senza rubare la scena · 6,00 cad.",
    items: [
      { name: "Giardiniera di Francesca", desc: "" },
      { name: "Patate Arrosto", desc: "" },
      { name: "Insalata Mista", desc: "" },
      { name: "Verdure Miste al Forno", desc: "" },
      { name: "Spinaci Saltati", desc: "" },
    ],
  },
];

const img = (id, w = 1000) =>
  `https://images.unsplash.com/${id}?w=${w}&q=70&auto=format&fit=crop`;

export const IMAGES = {
  hero: "/img/hero.jpg",
  concept: "/img/concept.jpg",
  wine: "/img/wine.jpg",
  events: "/img/eventi.jpg",
  sala: "/img/sala-viva.jpg",
  sala2: "/img/dettagli.jpg",
  dehors: "/img/dehors.jpg",
};

export const GALLERY = [
  { src: "/img/g-fiorentina.jpg", caption: "Fiorentina" },
  { src: "/img/g-braci.jpg", caption: "Braci" },
  { src: "/img/g-tartare.jpg", caption: "Tartare" },
  { src: "/img/g-calice.jpg", caption: "Calice" },
  { src: "/img/g-materia.jpg", caption: "Materia" },
  { src: "/img/sala.jpg", caption: "Sala" },
  { src: "/img/g-luci.jpg", caption: "Luci" },
  { src: "/img/g-pasta.jpg", caption: "Pasta" },
  { src: "/img/g-sera.jpg", caption: "Sera" },
  { src: "/img/g-dolce.jpg", caption: "Dolce" },
  { src: "/img/g-tagliata.jpg", caption: "Tagliata" },
  { src: "/img/dehors.jpg", caption: "Dehors" },
  { src: "/img/mercatini.jpg", caption: "Mercatini" },
  { src: "/img/g-formaggi.jpg", caption: "Formaggi" },
  { src: "/img/g-salumi.jpg", caption: "Salumi" },
  { src: "/img/tavola.jpg", caption: "Tavola" },
];

export const WINES = [
  { name: "Morellino di Scansano DOCG", area: "Maremma" },
  { name: "Monteregio di Massa Marittima DOC", area: "Colline Metallifere" },
  { name: "Bolgheri DOC", area: "Costa degli Etruschi" },
  { name: "Vermentino", area: "Costa Toscana" },
];

export const NAV_LINKS = [
  { label: "Cucina", href: "#concept" },
  { label: "Menu", href: "#menu" },
  { label: "Vino", href: "#vino" },
  { label: "Eccellenze", href: "#eccellenze" },
  { label: "Eventi", href: "#eventi" },
  { label: "Ambiente", href: "#ambiente" },
  { label: "Galleria", href: "#galleria" },
  { label: "Dove Siamo", href: "#dove-siamo" },
];
